import { useId } from 'react';
export const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
export const assignRef = (ref, value) => {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        try {
            // eslint-disable-next-line no-param-reassign
            ref.current = value;
        }
        catch (error) {
            throw new Error(`Cannot assign value "${value}" to ref "${ref}"`);
        }
    }
};
export function useForkedRef(...refs) {
    if (refs.every((ref) => ref == null)) {
        return null;
    }
    return (node) => {
        refs.forEach((ref) => {
            assignRef(ref, node);
        });
    };
}
export const isElement = (element) => {
    const E = typeof Element === 'undefined' ? function E() { } : Element;
    return element instanceof E;
};
export const contains = (parent, element) => {
    if (isElement(parent) && isElement(element)) {
        return parent.contains(element);
    }
    return false;
};
export function wrapEvent(theirHandler, ourHandler) {
    return (event) => {
        if (theirHandler) {
            theirHandler(event);
        }
        if (!event.defaultPrevented) {
            return ourHandler(event);
        }
        return undefined;
    };
}
export const useGeneratedId = (namespace = 'generated') => {
    const id = useId();
    return `${namespace}-${id}`;
};
